import { connect } from 'react-redux'
import ChatRoom from '../components/ChatRoom'
import { getChatMessages, postNewMessage } from '../api'
import { isLoading, chatRoomDataLoad, selectChat, addNewMessage } from '../actions'

const mapStateToProps = state => {
  const selectedChat = state.chats.find(c => c.id === state.selectedChatId)

  return {
    // props to App Component..
    chats: state.chats,
    chat: selectedChat || null,
    isLoading: state.isLoading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // props to App Component
    onLoad(chatId) {
      dispatch(isLoading())
      dispatch(selectChat(chatId))

      getChatMessages(chatId).then(data => {
        dispatch(chatRoomDataLoad(data))
      })
    },
    onAdd(text, chatId) {
      postNewMessage(text, chatId).then(message => {
        dispatch(addNewMessage(message, chatId))
      })
    }
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    chat: stateProps.chat,
    isLoading: stateProps.isLoading,
    onLoad() {
      const chatId = Number(ownProps.match.params.chatId)
      const chat = stateProps.chats.find(c => c.id === chatId)

      if (chat && !chat.messages) {
        dispatchProps.onLoad(chatId)
      }
    },
    onAddButtonClick(text, chatId) {
      dispatchProps.onAdd(text, chatId)
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(/* component */ ChatRoom)
